// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__3lzBr","spinner":"loader_spinner__1p99Q"};